import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function StoryItemTall({ post }) {
  const image = post.featuredImage
    ? getImage(post.featuredImage?.node?.small)
    : null
  const cats = post.storyCategorys.nodes.map(item => item.name).join()
  return (
    <div className={"mb-8  md:col-span-6 xl:col-span-4"}>
      <div className={"text-center mb-4"}>
        {image && (
          <Link to={`/${post.slug}/`}>
            <GatsbyImage image={image} alt={post.title} />
          </Link>
        )}
      </div>
      <div className={"col-span-9 sm:col-span-8"}>
        <p className={"mt-4 text-sm mb-2"}>
          {post.storyCategorys.nodes.map(item => (
            <Link
              key={`${item.slug}`}
              to={`/${item.slug}`}
              className={" mr-4 text-xs"}
            >
              {item.name}
            </Link>
          ))}
        </p>
        {/* highlight-start */}
        <Link to={`/${post.slug}`}>
          <h4 className={"text-2xl lg:text-4xl  mb-2"}>{post.title}</h4>
        </Link>
        {post.storyData.readTime && (
          <p className={"mb-4 text-xs"}>
            <span>Read Time:</span> {post.storyData.readTime}
          </p>
        )}
      </div>
    </div>
  )
}
